// ../constants/src/helpers.ts
var capitalizeEveryWord = (inputString) => {
  return inputString.replace(/\b\w+/g, (match) => {
    return match.charAt(0).toUpperCase() + match.slice(1).toLowerCase();
  });
};

export { capitalizeEveryWord };
